var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 169,
    viewBox: "0 0 169 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_250_23902",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 169,
    height: 169
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 169,
    height: 169,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_250_23902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.955 119.797C113.899 124.081 112.373 128.159 110.378 132.032C118.593 126.633 125.195 119.591 130.183 110.907C135.171 102.222 137.665 92.5397 137.665 81.8599C137.665 72.9404 135.846 64.6665 132.207 57.038C128.569 49.4095 123.699 42.8373 117.596 37.3213L133.792 21.1255H77.4584V77.4588L93.6542 61.263C100.696 66.4269 106.271 72.9111 110.378 80.7156C114.486 88.5201 116.54 97.1168 116.54 106.506C116.54 111.083 116.011 115.513 114.955 119.797Z",
    fill: "#FFC700"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2084 147.875L51.4042 131.68C45.1841 126.164 40.2842 119.591 36.7047 111.963C33.1252 104.335 31.3354 96.0606 31.3354 87.1411C31.3354 76.4613 33.8294 66.779 38.8172 58.0942C43.8051 49.4095 50.4653 42.3678 58.798 36.9692C56.8028 40.8422 55.2478 44.9205 54.1328 49.2041C53.0179 53.4878 52.4604 57.9182 52.4604 62.4953C52.4604 71.8842 54.5436 80.4809 58.7099 88.2854C62.8762 96.0899 68.4216 102.574 75.3459 107.738L91.5417 91.5422V147.875H35.2084Z",
    fill: "#FFC700"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStable);
export default __webpack_public_path__ + "static/media/stable.d05151ca995af4af7a941556298b521b.svg";
export { ForwardRef as ReactComponent };